/**
 * AI Scribe Recording Handoff — Desktop client helpers (LF-3743)
 *
 * The lawyer is authenticated, so these calls go through `directApiClient`
 * (browser → backend, one TLS hop) — same convention as LF-3017/LF-3214 for
 * new mutations. The mobile side has its own helpers in `handoff-mobile-api.ts`
 * that go via the dedicated public BFF.
 */

import { directApiClient } from '@/lib/api/direct-client';
import type { HandoffCreatedResponse } from './handoff-types';

/**
 * `POST /recordings/:id/handoff/regenerate` — rotate the token before any
 * mobile has claimed it. BE returns **409** with `HANDOFF_ALREADY_CLAIMED`
 * if the row was claimed between the desktop seeing `scan_expired` and
 * clicking Regenerate.
 */
export async function regenerateHandoff(
  recordingId: number
): Promise<HandoffCreatedResponse> {
  return directApiClient.post<HandoffCreatedResponse>(
    `/recordings/${recordingId}/handoff/regenerate`,
    {}
  );
}

/**
 * `DELETE /recordings/:id/handoff` — desktop cancels a pending handoff.
 * BE revokes the token (sets `handoff_revoked_at`) and soft-deletes the
 * recording row. Returns 204.
 */
export async function cancelHandoff(recordingId: number): Promise<void> {
  await directApiClient.delete(`/recordings/${recordingId}/handoff`);
}
